import AccountProfil from "./AccountProfil";
const routes = [
    {path : '/user/settings', component : () => <AccountProfil/>, isSidebar : true, isPublic : false},

]

export default routes;